var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg1AdultosNinos = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.964285714,18 L0.964285714,13.5 L0,13.5 L0,10.2 C0,9.54 0.578571429,9 1.28571429,9 L3.21428571,9 C3.92142857,9 4.5,9.54 4.5,10.2 L4.5,13.5 L3.53571429,13.5 L3.53571429,18 L0.964285714,18 L0.964285714,18 Z M10.8,18 L10.8,12.6 L13.5,12.6 L11.214,5.733 C10.962,4.995 10.278,4.5 9.504,4.5 L9.396,4.5 C8.622,4.5 7.929,4.995 7.686,5.733 L5.4,12.6 L8.1,12.6 L8.1,18 L10.8,18 L10.8,18 Z M2.25,8.2 C2.99925,8.2 3.6,7.59925 3.6,6.85 C3.6,6.10075 2.99925,5.5 2.25,5.5 C1.50075,5.5 0.9,6.10075 0.9,6.85 C0.9,7.59925 1.50075,8.2 2.25,8.2 L2.25,8.2 Z M9.45,3.6 C10.449,3.6 11.25,2.799 11.25,1.8 C11.25,0.801 10.449,0 9.45,0 C8.451,0 7.65,0.801 7.65,1.8 C7.65,2.799 8.451,3.6 9.45,3.6 L9.45,3.6 Z",
    id: "path-190"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-12",
    transform: "translate(-1250.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_wc",
    transform: "translate(1250.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-190"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#525252",
    xlinkHref: "#path-190"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg1AdultosNinos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/1_Adultos_ninos.b5078a38.svg";
export { ForwardRef as ReactComponent };